import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import api, { formatApiError } from "../../lib/api";

export function ProfileTab({ user, onSaved }) {
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "" });
  const [loading, setLoading] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/member/profile", form);
      toast.success("Profile updated");
      onSaved && onSaved();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="profile-tab" className="max-w-lg">
      <h2 className="font-heading text-2xl font-light text-ink mb-6">Your profile</h2>
      <form onSubmit={save} className="bg-white rounded-2xl p-8 border border-slate-100 space-y-5">
        <div>
          <Label className="text-ink">Full name</Label>
          <Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            data-testid="profile-name" className="mt-2 rounded-lg h-11" />
        </div>
        <div>
          <Label className="text-ink">Phone</Label>
          <Input value={form.phone} onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
            data-testid="profile-phone" className="mt-2 rounded-lg h-11" placeholder="(586) 555-0000" />
        </div>
        <div>
          <Label className="text-ink">Email</Label>
          <Input value={user?.email || ""} disabled className="mt-2 rounded-lg h-11 bg-stone text-[#8A9492]" />
          <p className="text-xs text-[#8A9492] mt-1">Email cannot be changed.</p>
        </div>
        <Button type="submit" disabled={loading} data-testid="profile-save"
          className="iri-gradient text-ink rounded-full h-11 px-8 font-medium">
          {loading ? "Saving…" : "Save changes"}
        </Button>
      </form>
    </div>
  );
}
